import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#indeterminate" }),
  /*#__PURE__*/_createTextVNode(" Indeterminate ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" The "),
  /*#__PURE__*/_createVNode("code", null, "indeterminate"),
  /*#__PURE__*/_createTextVNode(" property can help you to achieve a 'check all' effect. ")
], -1)
const _hoisted_4 = { class: "rounded border p-10" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Check all")
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { style: {"margin":"15px 0"} }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_el_checkbox, {
        indeterminate: _ctx.isIndeterminate,
        modelValue: _ctx.checkAll,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.checkAll = $event)),
        onChange: _ctx.handleCheckAllChange
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["indeterminate", "modelValue", "onChange"]),
      _hoisted_6,
      _createVNode(_component_el_checkbox_group, {
        modelValue: _ctx.checkedCities,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.checkedCities = $event)),
        onChange: _ctx.handleCheckedCitiesChange
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cities, (city) => {
            return (_openBlock(), _createBlock(_component_el_checkbox, {
              label: city,
              key: city
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(city), 1)
              ]),
              _: 2
            }, 1032, ["label"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "onChange"]),
      _createVNode(_component_CodeHighlighter, {
        "field-height": 400,
        lang: "html"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code4), 1)
        ]),
        _: 1
      })
    ])
  ]))
}